import { createContext } from "react";
import { DefaultPageResponse } from "@/types";

export const DefaultPropertiesContext = createContext<DefaultPageResponse | undefined>(undefined)
DefaultPropertiesContext.displayName = 'DefaultPropertiesContext'
